import { Injectable } from '@angular/core';
import { NavigationService } from './navigation.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private navigationService: NavigationService,
    private oauthService: OAuthService,
  ) { }

  async canActivate(): Promise<boolean> {
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    }
  
    const token = await this.getTokenAsync();
  
    if (token) {
      return true;
    }
  
    this.navigationService.appLogout();
    return false;
  }
  
  // # 3551
  private async getTokenAsync(): Promise<boolean | null> {
    return new Promise<boolean | null>((resolve, reject) => {
      const interval = setInterval(() => {
        const token = this.oauthService.hasValidAccessToken();
        if (token) {
          clearInterval(interval);
          resolve(token);
        }
      }, 100);
  
      setTimeout(() => {
        clearInterval(interval);
        resolve(null);
      }, 2000);
    });
  }
}
